/*
 * @Auther: 罗耀祖
 * @Date: 2021-07-12 15:53:28
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2021-07-29 16:29:36
 * @name: 全局组件
 * @Description: 全局组件
 * @FilePath: \backstage\src\globalComponents.js
 * @Author: DESKTOP-1QU67QM
 */

import Pagination from '@/components/public/Pagination.vue';
import layoutNormal from '@/components/public/layout-normal.vue';

const globalComponents = {
    install: function(Vue){
        Vue.component('Pagination', Pagination);
        Vue.component('layoutNormal', layoutNormal);  
    }
}

export default globalComponents;

